import { Component, Input } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.scss']
})
export class PrimaryButtonComponent {
  @Input() link: any = '';
  @Input() externLink: string = '';
  @Input() text: string = '';
  @Input() ariaLabel?: string;

  constructor(private langService: LanguageService) {}

  get routerLinkValue(): any {
    if (Array.isArray(this.link)) return this.link;
    const asString = (this.link || '').toString();
    if (!asString) return ['/home', this.langService.lang];
    const clean = asString.startsWith('/') ? asString.substring(1) : asString;
    return this.langService.build(clean, this.langService.lang);
  }
}
